import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObj: {
    DocType: "",
    DocName: "",
    DocNo: "",
    Date: new Date(),
    Loc: "",
    LocName: "",
    UnloadingBin: "",
    Auto: "A", //A-true M-false
    UnloadingBinName: "",
    A_DocStat: "ENTER",
    SuggBin:'',
    SuggBinCd:''
  },
  palletId:'',
  SummaryObj: { 
    GrnNo: 0,
  },

};

const SliceEasyPutAway = createSlice({
  name: "SliceEasyPutAway",
  initialState: { value: initialState },

  reducers: {
    Set_SliceEasyPutAway_HeadObj: (state, action) => {
      state.value.HeadObj = action.payload;
    },
    Set_SliceEasyPutAway_palletId: (state, action) => {
      state.value.palletId = action.payload;
    },
    Set_SliceEasyPutAway_HeadObj_Init: (state, action) => {
      state.value.HeadObj = initialState.HeadObj;
    },

    Set_SliceEasyPutAway_SummaryObj: (state, action) => {
      state.value.SummaryObj = action.payload;
    },
    SliceEasyPutAway_Init: (state) => {
      state.value = initialState;
    },

    Set_SliceEasyPutAway_HeadObj_New_Set: (state, action) => {
      state.value.HeadObj.Date = action.payload.Date;
    },
    Set_SliceEasyPutAway_HeadObj_SuggBin: (state, action) => {
      state.value.HeadObj.SuggBin = action.payload.SuggBin;
      state.value.HeadObj.SuggBinCd = action.payload.SuggBinCd;
    },
    Set_SliceEasyPutAway_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
    
  },
});

export const {
  Set_SliceEasyPutAway_HeadObj,
  Set_SliceEasyPutAway_SummaryObj,
  Set_SliceEasyPutAway_HeadObject_A_DocStat,
  SliceEasyPutAway_Init,
  Set_SliceEasyPutAway_HeadObj_Init,
  Set_SliceEasyPutAway_HeadObj_New_Set,
  Set_SliceEasyPutAway_HeadObj_SuggBin,
  Set_SliceEasyPutAway_palletId,
} = SliceEasyPutAway.actions;
export default SliceEasyPutAway.reducer;
